import * as React from 'react';
import {
  TeamMemberProfilePictureContainer,
  TeamMemberProfilePictureContent,
} from './components';

export const TeamMemberProfilePicture = () => (
  <TeamMemberProfilePictureContainer>
    <TeamMemberProfilePictureContent />
  </TeamMemberProfilePictureContainer>
);
